
<div class="bg-{{tellafriend.bgcolor}} p-2 rounded-lg">
@if(!(isAuthenticated$ | async) ){
    {{'tellafriend.not_authenticated' |translate}}
}@else {
<div [formGroup]="tellafriendForm" class="flex flex-col">
    <div class="form-field">
        <label class="{{tellafriend.color}} ">{{'tellafriend.email_of_your_friend' | translate}}</label>
        <input formControlName="email" id="email" name="{{'tellafriend.email_of_your_friend' | translate}}" required type="email">
        @if (hasError(tellafriendForm,'email', 'required')) {
        <div @collapse class="error">{{'validation.email_required' | translate}}</div>
        }
        @if (hasError(tellafriendForm,'email', 'invalidemail')) {
        <div @collapse class="error">{{'validation.email_invalid' | translate}}</div>
        }
    </div>
    <div class="form-field">
        <label class="{{tellafriend.color}} ">{{'tellafriend.body' | translate}}</label>
        <textarea formControlName="body" class="min-h-36 ring-e-dark-green" id="body" name="{{'tellafriend.body' | translate}}" required  type="text"></textarea>
        @if (hasError(tellafriendForm,'body', 'required')) {
        <div @collapse class="error">{{'validation.required' | translate}}</div>
        }
        <small class="italic {{tellafriend.color}}">{{'tellafriend.body_hint' | translate}}</small>
    </div>
    <div class="flex flex-row justify-around mt-6">
        <button [disabled]="!tellafriendForm.valid" (click)="sendTellAFriend()" class="button rounded-full border-e-white border">{{'tellafriend.invite_friend_btn' | translate}}</button>
        <small (click)="tellafriendForm.reset()" class="mt-2 text-center text-underline cursor-pointer {{tellafriend.color}}"><u>{{'tellafriend.clear_form' | translate}}</u></small>
    </div>
</div>
}
</div>